import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
type Refresh = () => void

interface cancelTrainPassesReservation {
  hashItemReserve: string
  nameReserve: string
  refresh: Refresh
  notify: any
  setLoadingCancelItem: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirm: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpen: React.Dispatch<React.SetStateAction<boolean>> | undefined
}

export const cancelTrainPassesReservation = async ({
  hashItemReserve,
  nameReserve,
  refresh,
  notify,
  setLoadingCancelItem,
  setNameReserve,
  setHashItemReserve,
  setConfirm,
  setOpen,
}: cancelTrainPassesReservation): Promise<void> => {
  try {
    setLoadingCancelItem(true)
    setOpen && setOpen(false)
    const response = await itemServices.refund_train_segment(hashItemReserve)
    if (response?.status === 'CANCELLED' || (response >= 200 && response <= 204)) {
      notify('ra.notification.canceled_item_reserve_success', {
        type: 'success',
        messageArgs: { reserve: nameReserve },
      })
      setNameReserve('')
      setHashItemReserve('')
      setConfirm && setConfirm(false)
      setLoadingCancelItem(false)
      return
    }
    setNameReserve('')
    setHashItemReserve('')
    setConfirm && setConfirm(false)
    setLoadingCancelItem(false)
    notify('ra.notification.canceled_item_reserve_error', {
      type: 'error',
      messageArgs: { reserve: nameReserve },
    })
  } catch (error) {
    notify('ra.notification.canceled_item_reserve_error', {
      type: 'error',
      messageArgs: { reserve: nameReserve },
    })
    setNameReserve('')
    setHashItemReserve('')
    setLoadingCancelItem(false)
    setConfirm && setConfirm(false)
    setOpen && setOpen(false)
  } finally {
    customAwait([refresh])
  }
}
